import { useMemo } from 'react';
import { useGetAllAvailableDeviceTypesQuery } from 'services/devices/devices.api';
import { RemoveExtention } from 'utils/stringUtils';

const SIREN_DEVICE_TYPE = 'Technology Bridge_Siren/Giant Voice';

export default function useSirenAudio(devices) {
  const { data: deviceTypes = {} } = useGetAllAvailableDeviceTypesQuery();

  // deviceTypes["RescAlert Devices"]["Technology Bridge_Siren/Giant Voice"].sirenTypes
  const sirenTypes = useMemo(() => {
    return deviceTypes?.['RescAlert Devices']?.[SIREN_DEVICE_TYPE]?.sirenTypes || [];
  }, [deviceTypes]);

  const filteredDevices = useMemo(() => {
    if (!devices) return [];

    if (!Array.isArray(devices)) {
      return devices?.device_type === SIREN_DEVICE_TYPE ? [devices] : [];
    }

    return devices.filter((d) => d?.device_type === SIREN_DEVICE_TYPE);
  }, [devices]);

  const { allAudio, universalAudio, sirenAudio } = useMemo(() => {
    if (!filteredDevices.length || !Array.isArray(sirenTypes)) {
      return { allAudio: [], universalAudio: [], sirenAudio: [] };
    }

    const allFiles = sirenTypes.map((audio) => {
      if (!audio) return audio;

      // only normalize names when device_ids exists
      if (audio.device_ids) {
        return {
          ...audio,
          name: RemoveExtention(audio.name),
          displayName: RemoveExtention(audio.displayName),
        };
      }
      return audio;
    });

    const universal = allFiles.filter((file) => !file?.device_ids);

    const targeted = allFiles.filter((file) => {
      if (!file?.device_ids) return false;

      return filteredDevices.some((device) => file.device_ids.includes(device.id));
    });

    return {
      allAudio: allFiles,
      universalAudio: universal,
      sirenAudio: targeted,
    };
  }, [filteredDevices, sirenTypes]);

  return { allAudio, sirenAudio, universalAudio };
}
